import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';

function Ambassador() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    fetchMyStats();
  }, []);

  const fetchMyStats = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const res = await axios.get('/api/referrals/my-stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setData(res.data);
    } catch (err) {
      console.error('Failed to fetch ambassador stats:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleBecomeAmbassador = async () => {
    setJoining(true);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post('/api/referrals/become-ambassador', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchMyStats();
    } catch (err) {
      console.error('Failed to become ambassador:', err);
    } finally {
      setJoining(false);
    }
  };

  const siteUrl = window.location.origin;

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="container" style={{ textAlign: 'center', padding: '60px 20px', color: '#6b7280' }}>
          Loading...
        </div>
      </div>
    );
  }

  // Not yet an ambassador — show the join page
  if (!data?.isAmbassador) {
    return (
      <div>
        <Navbar />
        <div className="container" style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div className="card" style={{ textAlign: 'center', padding: '40px 24px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚀</div>
            <h2 style={{ margin: '0 0 12px' }}>Become a Belong Ambassador</h2>
            <p style={{ color: '#6b7280', marginBottom: '24px', lineHeight: '1.6' }}>
              Help people with invisible identities find Belong. Share your personal referral link
              and earn money for every user who signs up and makes a connection.
            </p>

            <div style={{ background: '#f5f3ff', borderRadius: '12px', padding: '20px', marginBottom: '24px', textAlign: 'left' }}>
              <h3 style={{ margin: '0 0 12px', fontSize: '15px', color: '#4c1d95' }}>💰 How it works</h3>
              <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px', color: '#555', lineHeight: '2' }}>
                <li>Get your unique referral link</li>
                <li>Share it anywhere — social media, groups, friends</li>
                <li>When someone signs up AND makes their first connection, they count as "activated"</li>
                <li><strong>Earn $20 for every 100 activated users</strong> (US)</li>
                <li><strong>Earn $10 for every 100 activated users</strong> (India)</li>
                <li>Track your progress in real-time right here</li>
              </ul>
            </div>

            <button
              onClick={handleBecomeAmbassador}
              disabled={joining}
              style={{
                padding: '14px 32px', background: '#7C3AED', color: '#fff', border: 'none',
                borderRadius: '10px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', width: '100%'
              }}
            >
              {joining ? 'Setting up...' : 'Get My Referral Link →'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Ambassador dashboard
  const { agent, stats, earnings, recentSignups } = data;
  const referralLink = `${siteUrl}/register?ref=${agent.referral_code}`;
  const progressPercent = Math.round(((stats.activated_users % 100) / 100) * 100);

  return (
    <div>
      <Navbar />
      <div className="container" style={{ maxWidth: '700px', margin: '0 auto' }}>
        {/* Header */}
        <div className="card" style={{ textAlign: 'center' }}>
          <h2 style={{ margin: '0 0 4px' }}>🚀 Ambassador Dashboard</h2>
          <p style={{ color: '#6b7280', margin: 0, fontSize: '14px' }}>Track your referrals and earnings</p>
        </div>

        {/* Referral Link */}
        <div className="card" style={{ marginTop: '12px' }}>
          <h3 style={{ margin: '0 0 8px', fontSize: '15px' }}>🔗 Your Referral Link</h3>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <input
              type="text"
              readOnly
              value={referralLink}
              onClick={(e) => e.target.select()}
              style={{ flex: '1 1 200px', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '13px', minWidth: 0 }}
            />
            <button
              onClick={() => { navigator.clipboard.writeText(referralLink); alert('Link copied!'); }}
              style={{ padding: '10px 16px', background: '#7C3AED', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              Copy
            </button>
          </div>
          <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '8px' }}>
            Share this link on social media, WhatsApp, Reddit, college groups — anywhere people might benefit from Belong.
          </p>
        </div>

        {/* Metrics */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '12px', marginTop: '12px' }}>
          <div className="card" style={{ textAlign: 'center', padding: '16px' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#7C3AED' }}>{stats.total_signups}</div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>Signups</div>
          </div>
          <div className="card" style={{ textAlign: 'center', padding: '16px' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#059669' }}>{stats.activated_users}</div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>Activated</div>
            <div style={{ fontSize: '10px', color: '#9ca3af' }}>(made a connection)</div>
          </div>
          <div className="card" style={{ textAlign: 'center', padding: '16px' }}>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#d97706' }}>${earnings.earned}</div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>Earned</div>
          </div>
        </div>

        {/* Progress to next payout */}
        <div className="card" style={{ marginTop: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
            <span style={{ fontSize: '14px', fontWeight: '600' }}>Progress to next ${earnings.perHundred} payout</span>
            <span style={{ fontSize: '13px', color: '#6b7280' }}>{stats.activated_users % 100}/100 activated</span>
          </div>
          <div style={{ background: '#e5e7eb', borderRadius: '8px', height: '10px', overflow: 'hidden' }}>
            <div style={{ background: '#7C3AED', height: '100%', borderRadius: '8px', width: `${progressPercent}%`, transition: 'width 0.3s' }} />
          </div>
          <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '8px' }}>
            {earnings.toNextMilestone} more activated users to earn ${earnings.perHundred}.
            Rate: ${earnings.perHundred}/100 activated users ({agent.country === 'India' || agent.country === 'IN' ? '🇮🇳 India' : '🌍 International'} rate)
          </p>
        </div>

        {/* How to get paid */}
        <div className="card" style={{ marginTop: '12px', background: '#fffbeb', border: '1px solid #fde68a' }}>
          <h4 style={{ margin: '0 0 8px', fontSize: '14px', color: '#92400e' }}>💰 How to claim your reward</h4>
          <p style={{ margin: 0, fontSize: '13px', color: '#92400e', lineHeight: '1.6' }}>
            Once you reach 100 activated referrals, email <strong>belong@ourbelong.com</strong> with your referral code and payment details (UPI/PayPal/bank).
            We'll verify your count and send payment within 3-5 business days. You can claim at every 100-user milestone.
          </p>
        </div>

        {/* How activation works */}
        <div className="card" style={{ marginTop: '12px', background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
          <h4 style={{ margin: '0 0 8px', fontSize: '14px', color: '#166534' }}>✅ What counts as "activated"?</h4>
          <p style={{ margin: 0, fontSize: '13px', color: '#166534', lineHeight: '1.6' }}>
            A user you referred is "activated" when they sign up AND make at least one connection with another user on Belong.
            This ensures only real, engaged users count toward your earnings.
          </p>
        </div>

        {/* Recent activity */}
        {recentSignups && recentSignups.length > 0 && (
          <div className="card" style={{ marginTop: '12px' }}>
            <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>Recent Referrals</h3>
            {recentSignups.map((s, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: i < recentSignups.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                <span style={{ fontSize: '13px', color: '#374151' }}>
                  User #{stats.total_signups - i}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {s.activated_at ? (
                    <span style={{ fontSize: '11px', background: '#dcfce7', color: '#166534', padding: '2px 8px', borderRadius: '10px' }}>✅ Activated</span>
                  ) : (
                    <span style={{ fontSize: '11px', background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '10px' }}>⏳ Pending</span>
                  )}
                  <span style={{ fontSize: '11px', color: '#9ca3af' }}>
                    {new Date(s.signed_up_at).toLocaleDateString()}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Tips */}
        <div className="card" style={{ marginTop: '12px' }}>
          <h3 style={{ margin: '0 0 12px', fontSize: '15px' }}>💡 Tips to grow your referrals</h3>
          <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '13px', color: '#555', lineHeight: '2' }}>
            <li>Share in communities where people discuss mental health, ADHD, anxiety, chronic illness</li>
            <li>Reddit (r/ADHD, r/anxiety, r/chronicpain, r/neurodiversity)</li>
            <li>College mental health and diversity groups</li>
            <li>WhatsApp/Telegram groups for specific communities</li>
            <li>Personal social media with a genuine message about why Belong helps</li>
            <li>Focus on quality — activated users (who make connections) are what count</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Ambassador;
